/* eslint-disable react/display-name */
import React, { memo } from 'react';
import { withStyles } from '@material-ui/core/styles';
import TooltipComponent from '@material-ui/core/Tooltip';

const TooltipComponentBootstrap = withStyles(() => ({
  tooltip: {
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: '0.85rem',
    fontWeight: 400,
    textAlign: 'center',
    marginTop: '-10px',
    backgroundColor: 'var(--color-tooltip-default-bg)',
  },
}))(TooltipComponent);

export default memo((props) => (
  <TooltipComponentBootstrap enterTouchDelay={100} {...props} />
));
